<template>
    <div>
        <Navigation :route="navigationRoute"></Navigation>
        <div>
        <div class="tabs">
            <div :class="['tab', { 'active': tab == 1 }]" @click="handleTab(1)">网络自学</div>
            <div :class="['tab', { 'active': tab == 2 }]" @click="handleTab(2)">集中培训</div>
        </div>
        <div class="table" v-if="tab == 1">
          <div class="head">
            <div >序号</div>
            <div >类型</div>
            <div class="flex-2">名称</div>
            <div>学时</div>
            <div>时长（分钟）</div>
            <div>操作</div>
          </div>
          <div class="" >
            <div class="table-row" v-for="(e,i) in list" :key="i">
              <div>{{i+1}}</div>
              <div>{{e.type}}</div>
              <div class="flex-2">{{e.name}}</div>
              <div>{{e.hours}}</div>
              <div>{{e.duration}}</div>
              <div>
                <div class="table-btn" @click="handleCourse(e)">查看</div>
              </div>
            </div>
            
          </div>
        </div>
        <div class="table" v-if="tab == 2">
          <div class="head">
            <div>序号</div>
            <div class="flex-3">培训班</div>
            <div>主办单位</div>
            <div class="flex-2">培训时间</div>
            <div>学时</div>
          </div>
          <div class="" >
            <div class="table-row" v-for="(e,i) in lists" :key="i">
              <div>{{i+1}}</div>
              <div class="flex-3">
                <div  v-if="e.flag==1" >{{e.name}}</div>
                <div @click="toView(e)" v-else class="text">{{e.name}}</div>
                <!-- <el-button type="text " @click="toView(e)">{{e.name}}</el-button> -->
              </div>
              <div>{{e.orgName}}</div>
              <div class="flex-2">{{e.time}}</div>
              <div>{{e.hours}}</div>
            </div>
            
          </div>
        </div>
        </div>
        <!-- <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
            :page-size="10" layout="prev, pager, next, jumper" :total="tableData.total">
        </el-pagination> -->
    </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { networklist, details,traininglist } from "@/api/statistics.js";
import { mapState, mapMutations } from "vuex";
export default {
    name: "",
    components: {
        Navigation
    },
    data() {
        return {
            navigationRoute: [
                { name: '学时统计' },
                { name: '学时情况' },
            ],
            tab: 1,            
            query: {
                current: 1,
                size: 10
            },
            tableData: { //表格数据
                total: 0,
                records: []
            },
            list:[],
            lists:[]
        };
    },
    created() {
        this.getList()
    },
    computed: {

    },
    methods: {
        handleCourse(e) {
          if(e.id==0){
            this.$router.push({ path: '/studyTime/networkCourse' })
          }else{
            this.$router.push({ path: '/notice/detail',query:{
              id:e.id
            } })
          }
        },
        handleTab(index) {
            this.tab = index
            this.getList()
        },
        handleCurrentChange(val) {
            this.query.current = val
            this.getList()
        },
        getList(pageNumber, pageSize) {
            // this.query.current = pageNumber || this.query.current
            // this.query.size = pageSize || this.query.size
            if(this.tab==1){
              networklist(this.query).then(res => {
                this.list = res
              })
            }else{
              traininglist(this.query).then(res => {
                this.lists = res
              })
            }
            
        },
        toView(e){
            this.$router.push({ path: '/notice/detail',query:{
              id:e.id
            } })
            
        }
       
    },
};
</script>
<style lang="scss" scoped>
.tabs {
    display: flex;
    line-height: 30px;
    background: #FFFFFF;
    font-size: 14px;
    color: #EA0000;

    .tab {
        box-sizing: border-box;
        border: 1px solid #EA0000;
        border-radius: 3px 0 0 3px;
        padding: 0 22px;
        margin: 28px 0 25px 0;
        cursor: pointer;

        &:last-child {
            border-radius: 0 3px 3px 0;
            border-left: none;
        }
    }

    .active {
        background: #EA0000;
        color: #FFFFFF;
    }
}

.table {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  border-right: 1px solid #E3E3E3;
  border-bottom: 1px solid #E3E3E3;

  .head {
    display: flex;
    background: #EEEEEE;
    border-top: 1px solid #E3E3E3;
    border-left: 1px solid #E3E3E3;

    div {
      flex: 1;
      border-right: 1px solid #E3E3E3;
      padding: 10px 0;

      &:last-child {
        border-right: none;
      }
    }

    .flex-2 {
      flex: 2;
    }

    .flex-3 {
      flex: 3;
    }
  }

  .table-row {
    display: flex;

    >div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      border-top: 1px solid #E3E3E3;
      border-left: 1px solid #E3E3E3;
    }

    .flex-2 {
      flex: 2;
    }

    .flex-3 {
      flex: 3;
    }

    .table-btn {
      width: 74px;
      line-height: 24px;
      background: linear-gradient( 147deg, #F59A23 0%, #FF901A 98%);
      border-radius: 3px 3px 3px 3px;
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}

.text {
  color: #409eff;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
}
</style>